
import { animate, group, query, style, transition, trigger } from "@angular/animations";

export const routeTransition = trigger('routeTransition', [
    transition('* <=> *', [
        query(':enter, :leave', [
            style({
                position: 'absolute',
                width: '100%',
                top: 0,
                left: 0,
            })
        ], { optional: true }),

        query(':leave .star', style({ opacity: 0 }), { optional: true }),

        query(':enter', [
            style({
                transform: 'translateY(-15px)',
                opacity: 0,
            })
        ], { optional: true }),

        group([
            query(':leave', [
                animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({
                    opacity: 0,
                    transform: 'translateY(10px)',
                }))
            ], { optional: true }),

            query(':enter', [
                animate('500ms cubic-bezier(0.4, 0, 0.2, 1)', style({
                    transform: 'translateY(0)',
                    opacity: 1,
                }))
            ], { optional: true }),
        ])
    ])
]);
